module.exports = __webpack_public_path__ + "static/media/showville_logo_grey.a926596d.png";